import { ADMIN_AJAX_URL, CToken } from '../function/axios'
import qs from 'qs'


export let cancelAutoComplete
export let cancelPlaceDetails

export default {
  getAppConfig: () => {
    const payload = {
      action: 'get_app_config'
    }
    return window.siteAxios.post(`${ADMIN_AJAX_URL}`, qs.stringify(payload))
  },
  getAutoComplete: (keyword,country) =>{
    const payload = {
      action: 'get_autocomplete',
      keyword,
      country
    }
    return window.siteAxios.post(`${ADMIN_AJAX_URL}`, qs.stringify(payload),{
      cancelToken: new CToken(function(c){
        cancelAutoComplete = c
      })
    })
  },
  getPlaceDetails: (placeid) =>{
    const payload = {
      action: 'get_place_details',
      placeid
    }
    return window.siteAxios.post(`${ADMIN_AJAX_URL}`, qs.stringify(payload),{
      cancelToken: new CToken(function(c){
        cancelPlaceDetails = c
      })
    })
  }
}
